import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgramComponent} from './program.component';
import {ProgramRoutingModule} from './program-routing.module';
import {NgbModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';


@NgModule({
    declarations: [ProgramComponent],
    imports: [
        CommonModule,
        ProgramRoutingModule,
        NgbModule,
        CoreDirectivesModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ]
})
export class ProgramModule {
}
